var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _circle2, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _circle3, _path21, _circle4, _path22, _path23, _circle5, _path24, _circle6, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _circle7, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "undraw_online_discussion_re_nn7e",
    xmlns: "http://www.w3.org/2000/svg",
    width: 294.613,
    height: 255.194,
    viewBox: "0 0 294.613 255.194",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_78686",
    "data-name": "Path 78686",
    d: "M553.882,587.837a8.133,8.133,0,0,0,8.184,8.067l139.439-1a8.125,8.125,0,1,0-.116-16.25l-139.44,1A8.132,8.132,0,0,0,553.882,587.837Z",
    transform: "translate(-430.751 -384.744)",
    fill: "#f2f2f2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78687",
    "data-name": "Path 78687",
    d: "M585.789,591.879a.516.516,0,0,1,.514-.517l36.016-.129a.516.516,0,1,1,0,1.031h0l-36.016.129A.516.516,0,0,1,585.789,591.879Z",
    transform: "translate(-445.932 -390.729)",
    fill: "#ccc"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78688",
    "data-name": "Path 78688",
    d: "M585.868,600.513a.516.516,0,0,1,.514-.517l92.73-.55a.516.516,0,1,1,.006,1.031h0l-92.73.55A.516.516,0,0,1,585.868,600.513Z",
    transform: "translate(-445.97 -394.637)",
    fill: "#ccc"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78689",
    "data-name": "Path 78689",
    d: "M553.882,528.837a8.133,8.133,0,0,0,8.184,8.067l139.439-1a8.125,8.125,0,1,0-.116-16.25l-139.44,1A8.133,8.133,0,0,0,553.882,528.837Z",
    transform: "translate(-430.751 -356.674)",
    fill: "#f2f2f2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78690",
    "data-name": "Path 78690",
    d: "M582.868,541.513a.516.516,0,0,1,.514-.517l92.73-.55a.516.516,0,1,1,0,1.031h0l-92.73.55A.516.516,0,0,1,582.868,541.513Z",
    transform: "translate(-444.542 -366.566)",
    fill: "#ccc"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78691",
    "data-name": "Path 78691",
    d: "M582.868,531.513a.516.516,0,0,1,.514-.517l92.73-.55a.516.516,0,1,1,0,1.031h0l-92.73.55A.516.516,0,0,1,582.868,531.513Z",
    transform: "translate(-444.542 -361.808)",
    fill: "#ccc"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78692",
    "data-name": "Path 78692",
    d: "M497.749,663.654l-139.44-1a8.125,8.125,0,1,0-.116,16.25l139.44,1a8.125,8.125,0,0,0,.116-16.25Z",
    transform: "translate(-333.809 -424.71)",
    fill: "#f2f2f2"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78693",
    "data-name": "Path 78693",
    d: "M416.07,676.392l-36.016-.129a.516.516,0,1,1,0-1.031l36.016.129a.516.516,0,1,1,0,1.031Z",
    transform: "translate(-347.804 -430.694)",
    fill: "#ccc"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78694",
    "data-name": "Path 78694",
    d: "M473.518,685.027l-92.73-.55a.516.516,0,0,1,0-1.031h0l92.73.55a.516.516,0,1,1,0,1.031Z",
    transform: "translate(-348.153 -434.602)",
    fill: "#ccc"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2264",
    "data-name": "Ellipse 2264",
    cx: 3.67,
    cy: 3.67,
    r: 3.67,
    transform: "translate(287.274 167.837)",
    fill: "#f2f2f2"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2265",
    "data-name": "Ellipse 2265",
    cx: 3.67,
    cy: 3.67,
    r: 3.67,
    transform: "translate(287.274 198.766)",
    fill: "#f2f2f2"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78695",
    "data-name": "Path 78695",
    d: "M461.572,627.813,360.688,642.925a6.328,6.328,0,0,1-1.875-12.516L459.7,615.3a6.328,6.328,0,0,1,1.875,12.516Z",
    transform: "translate(-335.377 -402.145)",
    fill: "#25aae1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78696",
    "data-name": "Path 78696",
    d: "M401.8,645.44l-26.043,4a.377.377,0,1,1-.114-.746h0l26.043-4a.377.377,0,1,1,.114.746Z",
    transform: "translate(-345.796 -416.163)",
    fill: "#fff"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78697",
    "data-name": "Path 78697",
    d: "M444.3,639.587l-67.077,10.133a.377.377,0,0,1-.114-.746h0l67.077-10.133a.377.377,0,0,1,.115.746Z",
    transform: "translate(-346.492 -413.379)",
    fill: "#fff"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78698",
    "data-name": "Path 78698",
    d: "M502.815,611.378a2.706,2.706,0,0,1-2.485-3.288l-10.965-7.853,1.426-3.567,12.955,9.422a2.7,2.7,0,0,1-.931,5.285Z",
    transform: "translate(-400.056 -393.316)",
    fill: "#a0616a"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78699",
    "data-name": "Path 78699",
    d: "M451.45,540.969l-6.589,2.411a2.348,2.348,0,0,0-1.4,3.012q.039.106.088.208l8.984,18.741,21.645,15.6,3.318-5.286-16.4-14.931Z",
    transform: "translate(-378.148 -366.815)",
    fill: "#3f3d56"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78700",
    "data-name": "Path 78700",
    d: "M433.344,605.194c-7.509-.7-14.864-2.431-22.385-3.014l3.018-7.681,15.424,2.3Z",
    transform: "translate(-362.752 -392.283)",
    fill: "#a0616a"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78701",
    "data-name": "Path 78701",
    d: "M402.475,618.347l-.065.575-.537,4.621-.629.038-.034,5.787a2.694,2.694,0,0,1-1.1,3.152,2.21,2.21,0,0,1-.265.146,27.551,27.551,0,0,1,.341-9.016,16.075,16.075,0,0,1,1.074-3.206,13.123,13.123,0,0,1,.805-1.476C402.191,618.757,402.329,618.55,402.475,618.347Z",
    transform: "translate(-357.359 -403.63)",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78702",
    "data-name": "Path 78702",
    d: "M404.771,616.445l-.119.993v0l-.065.575-.345.046-.042,0Z",
    transform: "translate(-359.536 -402.725)",
    fill: "#ea5069"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78703",
    "data-name": "Path 78703",
    d: "M432.733,555.658l-1.3,7.539s3.149,7.095.982,8.863a2.216,2.216,0,0,0-.721,1.914l-.913-.081c-7.509-.7-14.864-2.431-22.385-3.014-.533-.042-1.062-.081-1.6-.107l2.316-6.588-1.565-5.856-1.622-6.075-.349-10a5.588,5.588,0,0,1,0-.568c0-.1,0-.2.012-.3a8.475,8.475,0,0,1,3.59-6.374.013.013,0,0,0,.008,0,8.49,8.49,0,0,1,1.112-.66,8.234,8.234,0,0,1,1.292-.51l.445-.134,2.408-3.9,2.792-.292,1.035-.107,6.746-.7,1.453,1.887.265.345,1.024,1.327,3.191,1.7a7.822,7.822,0,0,1,1.891,1.4,7.937,7.937,0,0,1,2.289,4.859,7.818,7.818,0,0,1,.023,1.273Z",
    transform: "translate(-360.193 -360.982)",
    fill: "#3f3d56"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78704",
    "data-name": "Path 78704",
    d: "M394.737,503.306a15.3,15.3,0,0,0,2.645,8.4A15.937,15.937,0,0,1,399.6,507.6a12.8,12.8,0,0,0,1.362,8.1,1.723,1.723,0,0,0,.146.094,5.023,5.023,0,0,0,4.369.536,9.8,9.8,0,0,1-.842-11.874,14.936,14.936,0,0,0,2.016-3.023c.677-1.816.026-3.816-.384-5.709-.384-1.762-.451-3.859.731-5.151a1.242,1.242,0,0,0-1.139-.524,2.35,2.35,0,0,0-1.6,1.389,10.136,10.136,0,0,1-1.032,1.939c-.872,1.055-2.357,1.3-3.609,1.86C396.592,496.587,394.81,499.989,394.737,503.306Z",
    transform: "translate(-355.033 -342.585)",
    fill: "#2f2e41"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78705",
    "data-name": "Path 78705",
    d: "M430.415,502.5c-.173-.606,1.021,3.1.445,3.167-2.624.3-6.226,1.868-8.054,2.6-.082-.01-.165-.019-.245-.031-.2-.022-.387-.053-.576-.088-4.256-.805-5.892-7.342-5.892-7.4,0-.294.705-8.365,1.816-8.485a8.19,8.19,0,0,1,.879-.048h2.757a12.81,12.81,0,0,1,1.731-.251h0c5.551-.423,9.927,2.96,9.518,7.077,0,0-.007.01-.01.014-.119.177-.223.344-.315.5s-.165.294-.23.43c-.506,1.051.795,2.374-.068,2.621-1.147.328,3.016,11.122-1.523,11.122C432.862,514.353,430.893,504.168,430.415,502.5Z",
    transform: "translate(-365.195 -343.479)",
    fill: "#2f2e41"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2266",
    "data-name": "Ellipse 2266",
    cx: 6.528,
    cy: 6.528,
    r: 6.528,
    transform: "translate(53.737 152.294)",
    fill: "#a0616a"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78706",
    "data-name": "Path 78706",
    d: "M431.237,499.277c-.109.057-.215.11-.324.162s-.228.11-.341.16c-2.186.992-3.965,1.1-5.045-.323a6.034,6.034,0,0,0-.5-2.174,3.5,3.5,0,0,1-.576,2.174H422.28c-2.239,1.486-3.389,1.641-1.835,6.52.433,1.359,2.156,9.27,1.478,10.443-.2-.021-2.282-8.686-2.471-8.722-4.256-.805-6.96-7.816-6.613-8.213a7.309,7.309,0,0,1,.758-3.252,7.479,7.479,0,0,1,2.842-3.092,13.181,13.181,0,0,1,2.271-.853l.056-.014c.24-.065.484-.124.729-.174a13.4,13.4,0,0,1,1.53-.232c.036,0,.073,0,.107,0a1.153,1.153,0,0,1,.583.16s0,0,0,0a1.1,1.1,0,0,1,.324.289,1.111,1.111,0,0,1,.237.691H424.7q.134,0,.269.007a6.491,6.491,0,0,1,6.258,6.1C431.235,499.05,431.237,499.162,431.237,499.277Z",
    transform: "translate(-363.633 -343.366)",
    fill: "#2f2e41"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2267",
    "data-name": "Ellipse 2267",
    cx: 4.301,
    cy: 4.301,
    r: 4.301,
    transform: "translate(49.031 145.222)",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78707",
    "data-name": "Path 78707",
    d: "M396.775,627.986a2.2,2.2,0,0,1-.265.146,2.7,2.7,0,0,1-2.387-4.845q.069-.034.14-.064l-.008-3.946-.008-4.644-.008-4.9,3.728-.92-.042,7.095-.015,3.137-.034,5.787A2.694,2.694,0,0,1,396.775,627.986Z",
    transform: "translate(-354.025 -399.094)",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78708",
    "data-name": "Path 78708",
    d: "M411.232,545.354l-.387.725-9.733,18.1-.292.541-1.377,11.862-.46,3.973-.119.993v0l-.065.575-.537,4.621-.629.038-1.058.069-2.6.161-1.944.123,0-3.11.034-23.57,7.072-12.924.173-.318,2.73-4.989a2.352,2.352,0,0,1,3.194-.932q.1.053.189.115Z",
    transform: "translate(-353.748 -366.831)",
    fill: "#3f3d56"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2268",
    "data-name": "Ellipse 2268",
    cx: 3.67,
    cy: 3.67,
    r: 3.67,
    transform: "translate(0 240.704)",
    fill: "#f2f2f2"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78709",
    "data-name": "Path 78709",
    d: "M778.355,411.478s-1.331,14.086-2.067,24.513V436q-.086,1.26-.161,2.435l-.391.035c-.268.027-.533.057-.8.084-4.287.456-8.533,1.212-12.793,1.868l-1.231.184a79.78,79.78,0,0,1-12.855,1.043h-.081c.034-.537.088-1.239.15-2.044.36-4.56,1.089-12.464,1.089-12.464l.679-4.575,2.22-14.987.015-.115.019-.13.107-.027,4.663-1.212,2.508-.648,1.457-2.01,1.94-2.677,8.069.993.591,2.2,1.093,4.057.035.13,4.234,2.458Z",
    transform: "translate(-523.096 -300.106)",
    fill: "#e6e6e6"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2269",
    "data-name": "Ellipse 2269",
    cx: 8.551,
    cy: 8.551,
    r: 8.551,
    transform: "translate(235.19 82.684)",
    fill: "#ffb6b6"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78710",
    "data-name": "Path 78710",
    d: "M766.865,367.677c.751.607.579,3.558,1.416,3.077s1.011-1.342,1.974-1.351a3.154,3.154,0,0,1,2.077.94c.1.093.2.19.295.286.087-.03.172-.058.262-.08a2.717,2.717,0,0,1,1.993.281,2.666,2.666,0,0,0-1.518.612c.184.206.371.413.567.6,1.638,1.6,5-.1,7.253-.49-1.88,2.053-1.51,3.2-1.042,5.944l0,.15c.1-.633,2.123-.6,1.789.238a10.8,10.8,0,0,1-1.562,2.3c2.762-1.913,4.992-4.551,5.484-7.737a4.683,4.683,0,0,0,.108-2.006,1.539,1.539,0,0,0-1.47-1.172,5.669,5.669,0,0,0-6.973-7.152,21.669,21.669,0,0,0-2.623,1.132,4.715,4.715,0,0,1-2.778.471,3.729,3.729,0,0,0-1.776-.256c-.674.2-.963.914-1.234,1.6a2.714,2.714,0,0,1,1.264.954,2.656,2.656,0,0,0-1.634-.066l-.029.008C768.1,367.053,768.067,367.322,766.865,367.677Z",
    transform: "translate(-532.084 -281.617)",
    fill: "#2f2e41"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78711",
    "data-name": "Path 78711",
    d: "M762.214,442.586l-1.231.184a79.78,79.78,0,0,1-12.855,1.043c.031-.679.05-1.361.069-2.044.027-.955.046-1.914.065-2.872q.132-6.518.265-13.031c0-.207.008-.418.012-.625.088-4.391.207-8.928,2.029-12.928a13.187,13.187,0,0,1,1.545-2.566c.031-.042.057-.081.088-.119.042-.054.084-.107.127-.157a12.74,12.74,0,0,1,1.626-1.684,9.368,9.368,0,0,1,6.819-2.466l.184.28.245.38c-.161,1.2-.326,2.4-.479,3.609a68.98,68.98,0,0,0-.606,15.693c.453,4.391,1.615,8.69,1.983,13.085.015.146.027.3.038.441A36.566,36.566,0,0,1,762.214,442.586Z",
    transform: "translate(-523.169 -302.271)",
    fill: "#3f3d56"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78712",
    "data-name": "Path 78712",
    d: "M787.475,441.339c.189-.818.367-1.641.556-2.469v-.005q1.093-4.907,2.191-9.813c.959-4.288,1.919-8.723,1.1-13.037A12.986,12.986,0,0,0,791,414.7c-.042-.142-.089-.283-.136-.425a13.071,13.071,0,0,0-1.337-2.831,9.63,9.63,0,0,0-6.3-4.613.872.872,0,0,0-.152-.031l-.582.54c-.121,1.117-.236,2.244-.362,3.366a69.585,69.585,0,0,1-3.166,15.638c-1.531,4.3-3.774,8.319-5.174,12.66-.005.026-.016.052-.021.073a37.093,37.093,0,0,0-1.117,4.4c.409-.063.823-.121,1.232-.183,4.262-.655,8.5-1.41,12.791-1.866Z",
    transform: "translate(-534.836 -302.979)",
    fill: "#3f3d56"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78713",
    "data-name": "Path 78713",
    d: "M810.482,356.577l-.245-2.355-.057-.545-.088-.874L808.2,334.629a2.474,2.474,0,0,0-1.085-2.823,2.373,2.373,0,0,0-3.252.821c-.011.019-.019.038-.031.058a2.488,2.488,0,0,0,.859,3.359,2.522,2.522,0,0,0,.357.169l-.015.51-.046,1.6-.035,1.208-.073,2.4-.027.932-.088,3.022-.084,2.915-.1,3.532-.08,2.715.978.249Z",
    transform: "translate(-549.513 -267.141)",
    fill: "#ffb6b6"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78714",
    "data-name": "Path 78714",
    d: "M811.214,379.378a4.274,4.274,0,0,0-.226-.924c-.495-.859-.8.341-.525-1.96.219-1.868-1.093-1.634-.621-2.033.779-.66-.3-.951-.767-1.308-.211-.157-.3-.326-.058-.545a1.63,1.63,0,0,1,.376-.245c.514-.268.219-.472-.464-.629a32.4,32.4,0,0,0-4.644-.433c-.376-.019-.683-.027-.874-.035-.142,0-.222,0-.222,0a1.537,1.537,0,0,0-.472.963,5.341,5.341,0,0,0,.176,2.328,8.225,8.225,0,0,0,.625,1.511,1.086,1.086,0,0,1,.13.591v0a.846.846,0,0,1-.441.568c-.518.345-.23,1.07.173,1.753a7.753,7.753,0,0,1,.867,1.473c0,.472-3.191,10.5-3.191,10.5l1.173,15.137a4.21,4.21,0,0,0,3.06.848,4.522,4.522,0,0,0,2.412-1.227,10.678,10.678,0,0,0,2.228-3.156C813.028,396.325,811.873,383.052,811.214,379.378Z",
    transform: "translate(-548.351 -286.073)",
    fill: "#3f3d56"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78715",
    "data-name": "Path 78715",
    d: "M706.322,338.9a2.485,2.485,0,0,1,1.174,3.261,2.387,2.387,0,0,1-.2.341l11.034,15.275-4.1,4.627L703.8,342.96a2.478,2.478,0,0,1-.688-2.946,2.372,2.372,0,0,1,3.152-1.146Z",
    transform: "translate(-501.646 -270.554)",
    fill: "#ffb6b6"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78716",
    "data-name": "Path 78716",
    d: "M745.531,398.9s-1.475,5.276-8.359,1.4-14.33-18.351-14.4-19.343.851-.168-.665-1.917c-1.232-1.423-.015-1.966-.629-2.032-1.618-.174,1.191-2.224-.807-1.989s4.516-4.394,4.516-4.394,1.187.029,2.093,2.559c.509,1.421.028,2.394,1.241,2.388s.694,2.874.95,3.254S738,385.717,738,385.717Z",
    transform: "translate(-509.923 -285.769)",
    fill: "#3f3d56"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2270",
    "data-name": "Ellipse 2270",
    cx: 39.884,
    cy: 39.884,
    r: 39.884,
    transform: "translate(186.565)",
    fill: "#25aae1"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78717",
    "data-name": "Path 78717",
    d: "M704.455,263.85a10.968,10.968,0,0,1,.943,2.494c.541,2.279.161,4.347-1.083,5.317a2.411,2.411,0,0,1-.4.263c-1.556.814-3.7-.045-5.424-1.967a10.964,10.964,0,0,1-1.51-2.2,10.721,10.721,0,0,1-.936-2.468c-.606-2.517-.089-4.786,1.471-5.6C699.583,258.607,702.689,260.473,704.455,263.85Z",
    transform: "translate(-498.272 -232.842)",
    fill: "#fff"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78718",
    "data-name": "Path 78718",
    d: "M704.019,272.525a5.737,5.737,0,0,1,.521,3.916,2.411,2.411,0,0,1-.4.263c-1.556.814-3.7-.045-5.424-1.967a10.961,10.961,0,0,1-1.51-2.2,10.722,10.722,0,0,1-.936-2.468A5.762,5.762,0,0,1,704.019,272.525Z",
    transform: "translate(-498.496 -237.622)",
    fill: "#3f3d56"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78719",
    "data-name": "Path 78719",
    d: "M733.991,248.4c1.7,3.242,1.541,6.7-.3,7.931a2.407,2.407,0,0,1-.239.143c-2.062,1.079-5.168-.788-6.934-4.165a10.677,10.677,0,0,1-.934-2.464c-.609-2.521-.092-4.791,1.469-5.607C729.119,243.161,732.224,245.027,733.991,248.4Z",
    transform: "translate(-512.325 -225.493)",
    fill: "#fff"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78720",
    "data-name": "Path 78720",
    d: "M733.4,257.234a5.739,5.739,0,0,1,.513,3.956,2.408,2.408,0,0,1-.239.143c-2.062,1.079-5.168-.788-6.934-4.165a10.677,10.677,0,0,1-.933-2.464,5.762,5.762,0,0,1,7.594,2.53Z",
    transform: "translate(-512.55 -230.347)",
    fill: "#3f3d56"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78721",
    "data-name": "Path 78721",
    d: "M708.581,300.366c4.7,8.979,13.806,13.485,20.348,10.064s8.039-13.474,3.343-22.454C727.114,295.5,719.3,299.733,708.581,300.366Z",
    transform: "translate(-504.354 -246.447)",
    fill: "#fff"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    id: "Path_78722",
    "data-name": "Path 78722",
    d: "M781.592,230.261a39.9,39.9,0,0,0-40.647-21.055,39.887,39.887,0,0,1,.123,79.076,39.874,39.874,0,0,0,40.523-58.021Z",
    transform: "translate(-519.752 -208.801)",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatEmpty);
export default __webpack_public_path__ + "static/media/chat-empty.be15d4c803d7694f41922fedeac61ad5.svg";
export { ForwardRef as ReactComponent };